import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
	faAward,
	faUniversity,
	faUserGraduate,
} from '@fortawesome/free-solid-svg-icons';

import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Jumbotron from 'react-bootstrap/Jumbotron';
import Row from 'react-bootstrap/Row';

import AboutServicesList from './AboutServicesList';

const AboutServices = () => {
	return (
		<Jumbotron
			className='custom-vertical-align m-0 p-0'
			style={{ background: '#fff' }}>
			<Container fluid className='custom-vertical-align m-0 p-0'>
				<Row className='custom-vertical-align m-0' style={{ width: '100%' }}>
					<Col
						xs={12}
						md={6}
						className='text-left justify-content-center custom-vertical-align left-about-services-background p-1 p-md-5'>
						<Container fluid className='m-4 m-md-5 p-0'>
							<div
								className='p-3 p-md-5 services-info-background'
								style={{ borderRadius: 15 }}>
								<div className='my-2'>
									<Row className='mx-3'>
										<Col xs={12} md={4} className='my-4 text-center'>
											<FontAwesomeIcon
												icon={faAward}
												size='5x'
												color='#fff'
												className=''
											/>
										</Col>
										<Col
											xs={12}
											md={8}
											className='mb-3 my-md-4 custom-vertical-align'>
											<p className='text-info-services mb-0'>
												Contamos con más de 10 años de experiencia en
												asesoramiento empresarial.
											</p>
										</Col>
									</Row>
									<Row className='mx-3'>
										<Col xs={12} md={4} className='my-4 text-center'>
											<FontAwesomeIcon
												icon={faUniversity}
												size='5x'
												color='#fff'
												className=''
											/>
										</Col>
										<Col
											xs={12}
											md={8}
											className='mb-3 my-md-4 custom-vertical-align'>
											<p className='text-info-services mb-0'>
												Nos importa que lo que transmitimos, sea de gran valor
												para nuestros clientes.
											</p>
										</Col>
									</Row>
									<Row className='mx-3'>
										<Col xs={12} md={4} className='my-4 text-center'>
											<FontAwesomeIcon
												icon={faUserGraduate}
												size='5x'
												color='#fff'
												className=''
											/>
										</Col>
										<Col
											xs={12}
											md={8}
											className='mb-4 my-md-4 custom-vertical-align'>
											<p className='text-info-services mb-0'>
												Nustra metodología busca que el aprendizaje sea eficaz e
												interactivo.
											</p>
										</Col>
									</Row>
								</div>
							</div>
						</Container>
					</Col>
					<Col
						xs={12}
						md={6}
						className='text-left justify-content-center custom-vertical-align p-1 p-md-5'>
						<div>
							<Row>
								<Col>
									<Container className='text-center my-3'>
										<h1 style={{ color: '#3367FF' }}>Servicios</h1>
										<div className='d-flex justify-content-center'>
											<div className='divider' />
										</div>
									</Container>
								</Col>
							</Row>
							<Row>
								<Col className='about-services-list text-center mb-5 px-2 pt-md-4 px-md-5'>
									<AboutServicesList />
								</Col>
							</Row>
						</div>
					</Col>
				</Row>
			</Container>
		</Jumbotron>
	);
};

export default AboutServices;
